import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService, { type IResponse } from 'services/dataService';
import { apiAssignTask } from 'services/dataService/resources/oneplatform/api';

import { getTasksByPatientQueryKey } from './use-get-tasks-by-patient';

import type { ITaskCard } from '../types';

export const useAssignTask = (patientGuid: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (taskGuid: string) =>
      dataService.createOne<{ task: ITaskCard }>(apiAssignTask(taskGuid), {}),
    onSuccess: (response: IResponse<{ task: ITaskCard }>) => {
      if (response.error) {
        const errorMessage =
          response.status === 409
            ? t('tasksDrawer.assignConflictError')
            : t('tasksDrawer.assignError');
        notificationController.error({
          message: errorMessage,
        });
        if (response.status === 409) {
          queryClient.invalidateQueries(getTasksByPatientQueryKey(patientGuid));
        }
        return;
      }

      notificationController.success({
        message: t('tasksDrawer.assignSuccess'),
      });
      queryClient.invalidateQueries(getTasksByPatientQueryKey(patientGuid));
    },
  });
};
